(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/bomben-draw.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/bomben-draw.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BombenDraw = Backbone.Model.extend({
    initialize: function() {
      this.resetExpertData();
    },

    resetExpertData: function() {
      this.set('expertData', []);
    }
  });
})(Backbone, _, svs);

 })(window);